import { render, staticRenderFns } from "./ParticipantChip.vue?vue&type=template&id=7fab5953&scoped=true"
import script from "./ParticipantChip.vue?vue&type=script&lang=js"
export * from "./ParticipantChip.vue?vue&type=script&lang=js"
import style0 from "./ParticipantChip.vue?vue&type=style&index=0&id=7fab5953&prod&lang=scss&scoped=true"
import style1 from "./ParticipantChip.vue?vue&type=style&index=1&id=7fab5953&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab5953",
  null
  
)

export default component.exports